// ---------------------------------------------------------

import MarketSummary from './component';

// ---------------------------------------------------------

export default MarketSummary;
